import { RestClient } from '../lib/RestClient'

class AgendaService extends RestClient {
  constructor() {
    super('agendapush')
  }

  async atividadesAgendadas(idAtividade, id, escola) {
    return this.request({
      method: 'GET',
      url: `/${idAtividade}/${id}?escola=${escola}`
    })
  }
}
export const Agenda = new AgendaService()
